import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

import { API_URL } from 'config';
import { getToken } from 'utils/auth';

const organizationUrl = `${API_URL}/identity/organizations/me`;

function authHeaders() {
  return { Authorization: `Bearer ${getToken()}` };
}

async function fetcher(url) {
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) {
    throw new Error(`Failed to load (${res.status})`);
  }
  return res.json();
}

// GET /identity/organizations/me - the caller's own organization, notably farmFocus
// (LIVESTOCK/CROPS/BOTH, see docs/product/08-farm-manager-gaps.md section G) which drives nav filtering.
export function useGetOrganization() {
  const { data, error, isLoading } = useSWR(organizationUrl, fetcher, { revalidateOnFocus: false });
  return useMemo(
    () => ({ organization: data ?? null, organizationLoading: isLoading, organizationError: error }),
    [data, isLoading, error]
  );
}

// A farmer who started livestock-only (or crops-only) can add the other side later from Profile.
export async function updateFarmFocus(farmFocus) {
  const res = await fetch(`${organizationUrl}/farm-focus`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ farmFocus })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Could not update farm focus');
  }
  mutate(organizationUrl, data, false);
  return data;
}
